import { worldForecastArraySchema } from "@/schemas/world-forecast-schema";
import { IFetchWorldPrevisionResult } from "@/types/world-forecast-type";

export const fetchWorldPrevision = async (
	cityId: string | string,
): Promise<IFetchWorldPrevisionResult> => {
	if (!cityId) {
		return {
			isLoading: false,
			error: null,
			data: [],
		};
	}

	try {
		const res = await fetch(
			`https://kuwait.exelys.io/world_forecast/world_forecast_${cityId}.json`,
		);

		if (!res.ok) {
			throw new Error("Une erreur est survenue");
		}

		const data = await res.json();

		const validatedData = worldForecastArraySchema.parse(data);

		return {
			isLoading: false,
			error: null,
			data: validatedData.data,
		};
	} catch {
		return {
			isLoading: false,
			error: "Une erreur est survenue",
			data: [],
		};
	}
};
